import { api } from "./http";

export const reviewDeskApi = {
  getStudyQueue: (deskId, options = {}) => {
    const limit = options.limit ?? 20;
    const includeNew = options.includeNew ?? true;
    const query = new URLSearchParams({
      deskId: String(deskId),
      limit: String(limit),
      includeNew: String(includeNew),
    });
    return api.get(`/api/ReviewCardDesk/study/query?${query.toString()}`);
  },

  getCategoryProgress: (categoryIds = [], options = {}) => {
    const includeNew = options.includeNew ?? true;
    const query = new URLSearchParams();
    query.set("includeNew", String(includeNew));
    categoryIds.forEach((id) => {
      query.append("categoryIds", String(id));
    });
    return api.get(`/api/ReviewCardDesk/study/category-progress?${query.toString()}`);
  },

  reviewCard: (payload) => api.post("/api/ReviewCardDesk/study/review", payload),
};
